var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppButton',_vm._b({staticClass:"btn-confirm",class:{ short: _vm.short },on:{"click":function($event){return _vm.$emit('save')}}},'AppButton',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }